class AuthService {
  getDecryptedUser = () => {
    const localStorage =
      window.localStorage.getItem("@wadashboardsandboxdata") ?? undefined;
    return JSON.parse(localStorage ?? "{}");
  };

  isAuthenticated = () => {
    let isAuth = false;
    const decrypt = this.getDecryptedUser();
    if (decrypt && decrypt.Auth) {
      const auth = JSON.parse(decrypt.Auth);
      if (
        auth &&
        auth.data &&
        auth.data.data &&
        auth.data.data.isAuthenticated
      ) {
        isAuth = true;
      }
    }

    return isAuth;
  };

  getToken = () => {
    let token = "";
    const decrypt = this.getDecryptedUser();
    if (decrypt && decrypt.Auth) {
      const auth = JSON.parse(decrypt.Auth);
      if (auth && auth.data && auth.data.data && auth.data.data.token) {
        token = auth.data.data.token;
      }
    }

    return token;
  };
}

export default AuthService;
